module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-7-9b40d24eb601c0d3d1e5fef9826f02d2.jpg";